import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Line } from 'react-chartjs-2';
import { useRequiredChartPlugins } from '../plugins/usePlugins';
import { ChartContainer } from '../styled';
const LineChart = React.forwardRef(function LineChart(props, ref) {
    const { 'data-testid': testId, ...chartProps } = props;
    useRequiredChartPlugins(chartProps.options);
    return (_jsx(ChartContainer, { "data-testid": testId, style: { height: chartProps.height ? `${chartProps.height}px` : undefined }, children: _jsx(Line, { ref: ref, ...chartProps, "data-testid": 'line-chart' }) }));
});
export default LineChart;
